import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'abo-services',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'abo-services',
            component: () => import('../pages/AboServicesPage.vue')
          },
          {
            path: 'create',
            name: 'abo-services.create',
            component: () => import('../pages/AboServiceCreatePage.vue')
          },
          {
            path: ':id',
            name: 'abo-services.show',
            component: () => import('../pages/AboServiceShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':id/edit',
            name: 'abo-services.edit',
            component: () => import('../pages/AboServiceEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
